var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-users",
    transform: "translate(1472 -28)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_974",
    "data-name": "Rectangle 974",
    width: 37,
    height: 37,
    transform: "translate(-1472 28)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "user-multiple",
    transform: "translate(-1467.237 32.763)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5886",
    "data-name": "Path 5886",
    d: "M31.845,30.485H30.139V26.22a4.27,4.27,0,0,0-4.264-4.265V20.25a5.977,5.977,0,0,1,5.97,5.97Z",
    transform: "translate(-5.714 -4.354)",
    fill: "#c1c1c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5887",
    "data-name": "Path 5887",
    d: "M19.308,30.485H17.6V26.22a4.27,4.27,0,0,0-4.265-4.265H8.22A4.27,4.27,0,0,0,3.956,26.22v4.265H2.25V26.22a5.977,5.977,0,0,1,5.97-5.97h5.117a5.977,5.977,0,0,1,5.97,5.97Z",
    transform: "translate(0 -4.354)",
    fill: "#c1c1c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5888",
    "data-name": "Path 5888",
    d: "M22.5,2.25V3.956a4.264,4.264,0,1,1,0,8.529v1.706a5.97,5.97,0,1,0,0-11.941Z",
    transform: "translate(-4.898)",
    fill: "#c1c1c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5889",
    "data-name": "Path 5889",
    d: "M11.6,3.956A4.264,4.264,0,1,1,7.331,8.22,4.264,4.264,0,0,1,11.6,3.956m0-1.706a5.97,5.97,0,1,0,5.97,5.97A5.97,5.97,0,0,0,11.6,2.25Z",
    transform: "translate(-0.816)",
    fill: "#c1c1c1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUsers);
export default __webpack_public_path__ + "static/media/icon-users.721c42f7cefa7deb48d57a2d4164add9.svg";
export { ForwardRef as ReactComponent };